<template>
  <div class="main_container main_container_fixed">
    <template v-if="loading">
      <loader />
    </template>
    <template v-else>
      <div class="sub_container w-row">
        <div class="column-10 w-col w-col-3"></div>
        <div class="column-2 w-col w-col-6"><img src="@/assets/images/Group-11560.svg" loading="lazy" width="247" alt="" class="image-4">
          <h1 class="heading-3">{{$t('GREETING')}}</h1>
        </div>
        <div class="column-16 w-col w-col-3"></div>
      </div>
      <a href="javascript:;" class="main_button w-button" @click="MotorOfferInit">{{$t('LETS_GO')}}</a>
      <!-- <datepicker-input v-model="test" classes="text_field_input text-field w-input" /> -->
    </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import Loader from '@/components/Loader.vue';

export default {
  metaInfo() {
    const title = this.$t('VEHICLE_INSURANCE');
    const url = window.location.href;
    const desc = this.$t('GIC_TITLE');
    return {
      title,
      // if no subcomponents specify a metaInfo.title, this title will be used
      // all titles will be injected into this template
      // titleTemplate: '%s | My Awesome Webapp'
      meta: [
        {
          property: 'og:title',
          content: title,
          /* // following template options are identical
          // template: '%s - My page',
          template: chunk => `${chunk} - My page`, */
          vmid: 'og:title'
        },
        {
          property: 'twitter:title',
          content: title,
          /* // following template options are identical
          // template: '%s - My page',
          template: chunk => `${chunk} - My page`, */
          vmid: 'twitter:title'
        },
        {
          property: 'description',
          content: desc,
          vmid: 'description'
        },
        {
          property: 'og:description',
          content: desc,
          vmid: 'og:description'
        },
        {
          property: 'twitter:description',
          content: desc,
          vmid: 'twitter:description'
        },
        {
          property: 'og:url',
          content: url,
          vmid: 'og:url'
        },
        {
          property: 'twitter:url',
          content: url,
          vmid: 'twitter:url'
        }
      ]
    };
  },
  data() {
    return {
      loading: false,
      // test: '0000-00-00'
    };
  },
  created() {
    console.log(this.$route);
    // document.title = this.$t('VEHICLE_INSURANCE');
  },
  components: {
    Loader
  },
  methods: {
    ...mapActions('motor', ['getMotorDataAction', 'motorResetStateAction']),
    async MotorOfferInit() {
      this.loading = true;
      await this.motorResetStateAction();
      await this.getMotorDataAction();
      this.loading = false;
      this.$router.push({ path: '/motor/offer' });
    }
  },
};
</script>
